function openMenu(e) {
  const elm = e.target.nextElementSibling;
  e.target.classList.toggle('opened-button');
  elm.classList.toggle('open');
  if (elm.classList.contains('open')) {
    elm.style.height = `${elm.scrollHeight}px`;
  } else {
    elm.style.height = '0';
  }
}

if (document.getElementById('login') !== null) {
  document.getElementById('login-reset-btn').addEventListener('click', function () {
    document.getElementById('login').classList.remove('current');
    document.getElementById('change-password').classList.add('current');
  });
}

if (document.getElementById('my-page') !== null) {
  document.getElementById('coupon-link').addEventListener('click', function () {
    document.getElementById('account-default').classList.remove('current');
    document.getElementById('account-coupon').classList.add('current');
  });

  document.querySelectorAll('.account-link').forEach((element) => {
    element.addEventListener('click', function () {
      document.getElementById('account-default').classList.add('current');
      document.getElementById('account-coupon').classList.remove('current');
    });
  });

  if (document.querySelectorAll('.add-address-count').length) {
    document.getElementById('no-address').remove();
  }

  const urlSearch = location.search;

  if (urlSearch) {
    const params = new URLSearchParams(urlSearch);
    const paramMap = Object.fromEntries(params.entries());

    if (paramMap.orderNumber) {
      const orderNumber = paramMap.orderNumber.replace('#', '').replace('%23', '');
      const targetNumber = `#${orderNumber}`;
      document.getElementById('search-order-number').value = targetNumber;
      document.querySelectorAll('.history__item').forEach((element) => {
        element.classList.add('hide');
        if (element.querySelector('.order-number').textContent === targetNumber) {
          element.classList.remove('hide');
          element.classList.add('history-show');
        }
      });
      document.getElementById('history-count').textContent =
        document.querySelectorAll('.history-show').length;
    }

    const now = new Date();
    const oneMonthAgo = new Date(now.getFullYear(), now.getMonth() - 1, now.getDate()).getTime();
    const threeMonthAgo = new Date(now.getFullYear(), now.getMonth() - 3, now.getDate()).getTime();
    const oneYearAgo = new Date(now.getFullYear() - 1, now.getMonth(), now.getDate()).getTime();

    if (paramMap.orderTime) {
      document.getElementById('search-order-time').value = paramMap.orderTime;

      document.querySelectorAll('.history__item').forEach((element) => {
        element.classList.add('hide');
        const orderDate = new Date(element.querySelector('.order-time').textContent);
        const orderDateTime = orderDate.getTime();
        if (paramMap.orderTime == '0') {
          element.classList.remove('hide');
          element.classList.add('history-show');
        }
        if (paramMap.orderTime == '1' && orderDateTime >= oneMonthAgo) {
          element.classList.remove('hide');
          element.classList.add('history-show');
        }
        if (paramMap.orderTime == '2' && orderDateTime >= threeMonthAgo) {
          element.classList.remove('hide');
          element.classList.add('history-show');
        }
        if (paramMap.orderTime == '3' && orderDateTime >= oneYearAgo) {
          element.classList.remove('hide');
          element.classList.add('history-show');
        }
      });
      document.getElementById('history-count').textContent =
        document.querySelectorAll('.history-show').length;
    }
  } else {
    document.getElementById('history-count').textContent =
      document.querySelectorAll('.history__item').length;
  }
}

if (document.getElementById('register') !== null) {
  const lastNameInput = document.querySelector('input[name="customer[last_name]"]');
  const firstNameInput = document.querySelector('input[name="customer[first_name]"]');
  const kanaLastInput = document.querySelector('input[name="customer[note][カナ/姓]"]');
  const kanaFirstInput = document.querySelector('input[name="customer[note][カナ/名]"]');
  const emailInput = document.querySelector('input[name="customer[email]"]');
  const mailConfirmInput = document.querySelector('#mail-confirm');
  const passwordInput = document.querySelector('input[name="customer[password]"]');
  const passwordConfirmInput = document.querySelector('#password-confirm');
  const birthYearSelect = document.querySelector('select[name="customer[note][生年月日/年]"]');
  const birthMonthSelect = document.querySelector('select[name="customer[note][生年月日/月]"]');
  const birthDateSelect = document.querySelector('select[name="customer[note][生年月日/日]"]');
  const agreeCheck = document.querySelector('#agree-check');
  const submitButton = document.querySelector('.register__submit');
  const registerError = document.getElementById('register-error');
  const emailError = document.querySelector('#email-error');
  const emailConfirmError = document.querySelector('.email-confirm-error');
  const passwordConfirmError = document.querySelector('.password-confirm-error');

  const setSubmitState = (hasError) => {
    submitButton.disabled = hasError;
    submitButton.classList.toggle('disable', hasError);
    registerError.classList.toggle('show', hasError);
  };

  const updateRegisterState = () => {
    const isLastNameEmpty = lastNameInput.value === '';
    const isFirstNameEmpty = firstNameInput.value === '';
    const isKanaLastEmpty = kanaLastInput.value === '';
    const isKanaFirstEmpty = kanaFirstInput.value === '';
    const isEmailEmpty = emailInput.value === '';
    const isEmailConfirmEmpty = mailConfirmInput.value === '';
    const isPasswordEmpty = passwordInput.value === '';
    const isPasswordConfirmEmpty = passwordConfirmInput.value === '';
    const isBirthYearEmpty = birthYearSelect.value === '';
    const isBirthMonthEmpty = birthMonthSelect.value === '';
    const isBirthDateEmpty = birthDateSelect.value === '';
    const hasEmailFormatError = emailError.classList.contains('input-error');
    const emailMismatch =
      mailConfirmInput.value !== '' && emailInput.value !== mailConfirmInput.value;
    const passwordMismatch =
      passwordConfirmInput.value !== '' && passwordInput.value !== passwordConfirmInput.value;

    emailConfirmError.classList.toggle('show', emailMismatch);
    passwordConfirmError.classList.toggle('show', passwordMismatch);

    const hasError =
      isLastNameEmpty ||
      isFirstNameEmpty ||
      isKanaLastEmpty ||
      isKanaFirstEmpty ||
      isEmailEmpty ||
      isEmailConfirmEmpty ||
      isPasswordEmpty ||
      isPasswordConfirmEmpty ||
      isBirthYearEmpty ||
      isBirthMonthEmpty ||
      isBirthDateEmpty ||
      hasEmailFormatError ||
      !agreeCheck.checked ||
      emailMismatch ||
      passwordMismatch;

    setSubmitState(hasError);
  };

  emailInput.addEventListener('input', function () {
    const mail = emailInput.value;
    if (mail === '') {
      emailError.classList.remove('show');
      emailError.classList.remove('input-error');
    } else if (
      !mail.match(/^([a-zA-Z0-9])+([a-zA-Z0-9._-])*@([a-zA-Z0-9_-])+([a-zA-Z0-9._-]+)+$/)
    ) {
      emailError.classList.add('show');
      emailError.classList.add('input-error');
    } else {
      emailError.classList.remove('show');
      emailError.classList.remove('input-error');
    }
    updateRegisterState();
  });

  document.querySelectorAll('input, select').forEach((element) => {
    element.addEventListener('change', function () {
      updateRegisterState();
    });
  });

  updateRegisterState();
}
